import React from 'react'
import { l } from '@manychat/manyui'

import { KnowledgeTypesList } from 'apps/aiAutomation/components/KnowledgeTypesList'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'

import cm from './styles.module.css'

export const KnowledgeEntryTypePicker = () => (
  <div className={cm.wrapper}>
    <SidebarHeader title={l.translate('Add more info')} />

    <div className="p-a-md o-auto">
      <p className="m-b text-subheading">
        {l.translate('Give AI the info it needs to deliver the best answers.')}
      </p>

      <KnowledgeTypesList />
    </div>
  </div>
)
